/* GGC YMM Fitment Search — in-house replacement for EasySearch-YMM.
 * Data: a static JSON tree {v, order:['year','make','model'], tree:{year:{make:{model:tag}}}}
 * Behavior: cascading Year -> Make -> Model selects, then redirect to Shopify search filtered
 * by the product fitment tag (same tags EasySearch uses today), plus a localStorage Garage.
 * No external service. Vanilla JS, no dependencies.
 */
(function () {
  "use strict";

  var GARAGE_KEY = "ggc_ymm_garage";
  var LAST_KEY = "ggc_ymm_last";

  function h(tag, attrs, children) {
    var el = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === "class") el.className = attrs[k];
      else if (k === "text") el.textContent = attrs[k];
      else el.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { el.appendChild(c); });
    return el;
  }

  function opt(value, label, disabled, selected) {
    var o = document.createElement("option");
    o.value = value; o.textContent = label;
    if (disabled) o.disabled = true;
    if (selected) o.selected = true;
    return o;
  }

  function readJSON(key, fallback) {
    try { return JSON.parse(localStorage.getItem(key)) || fallback; }
    catch (e) { return fallback; }
  }
  function writeJSON(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
  }

  var ACTIVE_KEY = "ggc_ymm_active"; // the currently-selected vehicle that filters browsing

  function GGCYmm(root) {
    this.root = root;
    this.indexUrl = root.getAttribute("data-index-url");
    // Collection handle of the page we're on ("" on non-collection pages). Drives in-collection filtering.
    this.collectionHandle = root.getAttribute("data-collection-handle") || "";
    this.title = root.getAttribute("data-title") || "Shop Your Ride";
    this.btnText = root.getAttribute("data-btn-text") || "Search";
    this.autosubmit = root.getAttribute("data-autosubmit") === "true";
    this.data = null;
    this.tree = null;
    this.sel = { year: "", make: "", model: "" };
    this.render();
    this.bindLazyLoad();
    this.renderGarage();
    this.applyActiveVehicle(); // keep browsing filtered to the active vehicle
  }

  // Build the storefront URL that shows only products fitting `tag`.
  // Shopify's native /collections/<handle>/<tag> tag filter is exact + server-side + paginated.
  GGCYmm.prototype.fitUrl = function (tag, handle) {
    var h = (handle != null ? handle : "all") || "all"; // vehicle search always covers the whole store
    return "/collections/" + h + "/" + encodeURIComponent(tag);
  };

  function getActive() { return readJSON(ACTIVE_KEY, null); }
  function setActive(v) { writeJSON(ACTIVE_KEY, v); }

  GGCYmm.prototype.render = function () {
    var self = this;
    this.root.innerHTML = "";
    var wrap = h("div", { class: "ggc-ymm__inner" });

    if (this.root.getAttribute("data-show-title") !== "false") {
      wrap.appendChild(h("div", { class: "ggc-ymm__title", text: this.title }));
    }

    this.fields = h("div", { class: "ggc-ymm__fields" });
    this.selYear = this.buildSelect("year", "Year");
    this.selMake = this.buildSelect("make", "Make");
    this.selModel = this.buildSelect("model", "Model");
    this.fields.appendChild(this.wrapField("Year", this.selYear));
    this.fields.appendChild(this.wrapField("Make", this.selMake));
    this.fields.appendChild(this.wrapField("Model", this.selModel));
    wrap.appendChild(this.fields);

    var actions = h("div", { class: "ggc-ymm__actions" });
    this.btnSearch = h("button", { class: "ggc-ymm__btn ggc-ymm__btn--primary", type: "button", text: this.btnText });
    this.btnSearch.disabled = true;
    this.btnSearch.addEventListener("click", function () { self.doSearch(); });
    this.btnClear = h("button", { class: "ggc-ymm__btn ggc-ymm__btn--clear", type: "button", text: "Clear filters" });
    this.btnClear.addEventListener("click", function () { self.clear(); });
    // "Add to garage" with the same ＋ icon as the Nexus widget
    this.btnGarage = h("button", { class: "ggc-ymm__btn ggc-ymm__btn--garage", type: "button" });
    var gIcon = h("span", { class: "ggc-ymm__btn-icon" });
    gIcon.innerHTML = '<svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true"><path d="M5.33 11.33a.67.67 0 1 0 1.34 0V6.67h4.66a.67.67 0 1 0 0-1.34H6.67V.67a.67.67 0 0 0-1.34 0v4.66H.67a.67.67 0 0 0 0 1.34h4.66v4.66Z"/></svg>';
    this.btnGarage.appendChild(gIcon);
    this.btnGarage.appendChild(h("span", { text: "Add to garage" }));
    this.btnGarage.disabled = true;
    this.btnGarage.addEventListener("click", function () { self.addToGarage(); });
    actions.appendChild(this.btnSearch);
    actions.appendChild(this.btnClear);
    actions.appendChild(this.btnGarage);
    wrap.appendChild(actions);

    this.garageEl = h("div", { class: "ggc-ymm__garage" });
    wrap.appendChild(this.garageEl);

    this.statusEl = h("div", { class: "ggc-ymm__status", "aria-live": "polite" });
    wrap.appendChild(this.statusEl);

    this.root.appendChild(wrap);
  };

  GGCYmm.prototype.wrapField = function (label, select) {
    var f = h("label", { class: "ggc-ymm__field" });
    f.appendChild(h("span", { class: "ggc-ymm__label", text: label }));
    f.appendChild(select);
    return f;
  };

  GGCYmm.prototype.buildSelect = function (level, placeholder) {
    var self = this;
    var s = document.createElement("select");
    s.className = "ggc-ymm__select ggc-ymm__select--" + level;
    s.disabled = true;
    s.appendChild(opt("", "Select " + placeholder, true, true));
    s.addEventListener("change", function () { self.onChange(level, s.value); });
    return s;
  };

  GGCYmm.prototype.bindLazyLoad = function () {
    var self = this;
    var trigger = function () { self.load(); };
    // Load on first interaction with the widget to keep initial page light.
    this.root.addEventListener("mouseenter", trigger, { once: true });
    this.selYear.addEventListener("focus", trigger, { once: true });
    this.selYear.addEventListener("mousedown", trigger, { once: true });
  };

  GGCYmm.prototype.load = function () {
    var self = this;
    if (this.data || this._loading) return;
    this._loading = true;
    this.setStatus("Loading vehicles…");
    fetch(this.indexUrl, { credentials: "omit" })
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function (data) {
        self.data = data; self.tree = data.tree;
        self.setStatus("");
        self.populateYears();
        self.restoreLast();
      })
      .catch(function (e) {
        self._loading = false;
        self.setStatus("Could not load vehicle data. Please retry.");
        if (window.console) console.error("[GGC-YMM] index load failed", e);
      });
  };

  GGCYmm.prototype.populateYears = function () {
    var years = Object.keys(this.tree).sort(function (a, b) { return parseInt(b, 10) - parseInt(a, 10); });
    this.fillSelect(this.selYear, years, "Year");
    this.selYear.disabled = false;
  };

  GGCYmm.prototype.fillSelect = function (select, values, placeholder) {
    select.innerHTML = "";
    select.appendChild(opt("", "Select " + placeholder, true, true));
    values.forEach(function (v) { select.appendChild(opt(v, v)); });
  };

  GGCYmm.prototype.onChange = function (level, value) {
    if (level === "year") {
      this.sel.year = value; this.sel.make = ""; this.sel.model = "";
      if (value && this.tree[value]) {
        var makes = Object.keys(this.tree[value]).sort();
        this.fillSelect(this.selMake, makes, "Make");
        this.selMake.disabled = false;
      } else { this.resetSelect(this.selMake, "Make"); }
      this.resetSelect(this.selModel, "Model");
    } else if (level === "make") {
      this.sel.make = value; this.sel.model = "";
      var node = (this.tree[this.sel.year] || {})[value];
      if (value && node) {
        var models = Object.keys(node).sort();
        this.fillSelect(this.selModel, models, "Model");
        this.selModel.disabled = false;
      } else { this.resetSelect(this.selModel, "Model"); }
    } else if (level === "model") {
      this.sel.model = value;
    }
    this.updateState();
  };

  GGCYmm.prototype.resetSelect = function (select, placeholder) {
    select.innerHTML = "";
    select.appendChild(opt("", "Select " + placeholder, true, true));
    select.disabled = true;
  };

  GGCYmm.prototype.currentTag = function () {
    var t = this.tree && this.tree[this.sel.year] && this.tree[this.sel.year][this.sel.make];
    return (t && t[this.sel.model]) || "";
  };

  GGCYmm.prototype.updateState = function () {
    var ready = !!(this.sel.year && this.sel.make && this.sel.model && this.currentTag());
    this.btnSearch.disabled = !ready;
    this.btnGarage.disabled = !ready;
    if (ready && this.autosubmit) this.doSearch();
  };

  GGCYmm.prototype.label = function () {
    return [this.sel.year, this.sel.make, this.sel.model].filter(Boolean).join(" ");
  };

  GGCYmm.prototype.navigate = function (url, meta) {
    // Cancelable hook: lets host pages (and tests/analytics) intercept the redirect.
    var ev;
    try {
      ev = new CustomEvent("ggc-ymm:navigate", { detail: Object.assign({ url: url }, meta || {}), cancelable: true, bubbles: true });
    } catch (e) { ev = null; }
    var proceed = ev ? this.root.dispatchEvent(ev) : true;
    if (proceed) window.location.assign(url);
  };

  GGCYmm.prototype.doSearch = function () {
    var tag = this.currentTag();
    if (!tag) return;
    var vehicle = { year: this.sel.year, make: this.sel.make, model: this.sel.model, tag: tag, label: this.label() };
    writeJSON(LAST_KEY, this.sel);
    setActive(vehicle);
    this.navigate(this.fitUrl(tag), { tag: tag, vehicle: this.label() });
  };

  GGCYmm.prototype.clear = function () {
    this.sel = { year: "", make: "", model: "" };
    if (this.data) this.populateYears();
    this.resetSelect(this.selMake, "Make");
    this.resetSelect(this.selModel, "Model");
    this.selYear.value = "";
    this.updateState();
    localStorage.removeItem(LAST_KEY);
    var hadActive = getActive();
    localStorage.removeItem(ACTIVE_KEY);
    // If we're on a vehicle-filtered collection URL, drop back to the plain collection.
    var m = window.location.pathname.match(/^\/collections\/([^\/]+)\/[^\/]+\/?$/);
    if (hadActive && m && hadActive.tag && window.location.pathname.indexOf(encodeURIComponent(hadActive.tag)) !== -1) {
      this.navigate("/collections/" + m[1]);
    }
  };

  // Keep browsing filtered to the active vehicle: rewrite collection links + auto-filter a bare collection page.
  GGCYmm.prototype.applyActiveVehicle = function () {
    var active = getActive();
    if (!active || !active.tag) return;
    // Show the proper-cased vehicle name in the heading — ONLY when this page is actually
    // showing that vehicle's parts (the URL carries its tag), never on tire-size or other pages.
    if (active.label && active.tag && !window.__ggcTitleSet &&
        window.location.pathname.indexOf(active.tag) !== -1) {
      var t = document.querySelector("[data-ggc-vehicle-title]");
      if (t) { t.textContent = active.label; window.__ggcTitleSet = true; }
    }
    // A saved vehicle never hard-locks browsing: collections stay whole, the vehicle bar offers an optional fit filter.
    if (this.collectionHandle) this.load();
  };

  GGCYmm.prototype.rewriteCollectionLinks = function (tag) {
    var enc = encodeURIComponent(tag);
    var links = document.querySelectorAll('a[href*="/collections/"]');
    Array.prototype.forEach.call(links, function (a) {
      var href = a.getAttribute("href") || "";
      var m = href.match(/^(?:https?:\/\/[^/]+)?(\/collections\/[a-z0-9_-]+)\/?(?:[?#].*)?$/i);
      if (!m) return;                       // skip product links, already-tagged, or non-collection
      a.setAttribute("href", m[1] + "/" + enc);
    });
  };

  /* ---------- Garage ---------- */
  GGCYmm.prototype.addToGarage = function () {
    var tag = this.currentTag();
    if (!tag) return;
    var garage = readJSON(GARAGE_KEY, []);
    var label = this.label();
    if (!garage.some(function (g) { return g.tag === tag && g.label === label; })) {
      garage.unshift({ year: this.sel.year, make: this.sel.make, model: this.sel.model, tag: tag, label: label });
      garage = garage.slice(0, 8);
      writeJSON(GARAGE_KEY, garage);
    }
    this.renderGarage();
    if (window.GGCGarageRefresh) window.GGCGarageRefresh();
    // Visible confirmation on the button + flash the Garage tab.
    var btn = this.btnGarage, t = btn.querySelector("span:last-child");
    if (t) { var orig = t.textContent; t.textContent = "✓ In garage"; setTimeout(function () { t.textContent = orig; }, 1600); }
    var gtab = document.querySelector(".ggc-ymm-garage-tab");
    if (gtab) { gtab.classList.add("ggc-ymm-garage-tab--flash"); setTimeout(function () { gtab.classList.remove("ggc-ymm-garage-tab--flash"); }, 1200); }
  };

  GGCYmm.prototype.renderGarage = function () {
    var self = this;
    var garage = readJSON(GARAGE_KEY, []);
    this.garageEl.innerHTML = "";
    if (!garage.length) return;
    this.garageEl.appendChild(h("span", { class: "ggc-ymm__garage-label", text: "My Garage:" }));
    garage.forEach(function (g) {
      var chip = h("span", { class: "ggc-ymm__chip" });
      var pick = h("button", { class: "ggc-ymm__chip-go", type: "button", text: g.label });
      pick.addEventListener("click", function () { self.selectGarage(g); });
      var del = h("button", { class: "ggc-ymm__chip-x", type: "button", text: "×", "aria-label": "Remove " + g.label });
      del.addEventListener("click", function (e) { e.stopPropagation(); self.removeGarage(g); });
      chip.appendChild(pick); chip.appendChild(del);
      self.garageEl.appendChild(chip);
    });
  };

  GGCYmm.prototype.selectGarage = function (g) {
    // 1-click: set this saved vehicle active and show the parts that fit it.
    writeJSON(LAST_KEY, { year: g.year, make: g.make, model: g.model });
    setActive({ year: g.year, make: g.make, model: g.model, tag: g.tag, label: g.label });
    this.navigate(this.fitUrl(g.tag), { tag: g.tag, vehicle: g.label });
  };

  GGCYmm.prototype.removeGarage = function (g) {
    var garage = readJSON(GARAGE_KEY, []).filter(function (x) { return !(x.tag === g.tag && x.label === g.label); });
    writeJSON(GARAGE_KEY, garage);
    this.renderGarage();
  };

  GGCYmm.prototype.restoreLast = function () {
    // Prefer the active vehicle (what's currently filtering browsing), fall back to the last selection.
    var last = getActive() || readJSON(LAST_KEY, null);
    if (!last || !last.year) return;
    if (!this.tree[last.year]) return;
    this.selYear.value = last.year; this.onChange("year", last.year);
    if (this.tree[last.year][last.make]) {
      this.selMake.value = last.make; this.onChange("make", last.make);
      if (this.tree[last.year][last.make][last.model]) {
        this.selModel.value = last.model; this.onChange("model", last.model);
      }
    }
  };

  GGCYmm.prototype.setStatus = function (msg) { this.statusEl.textContent = msg || ""; };


  /* ---------- Vehicle bar: optional fit filter on collection pages (never a hard lock) ---------- */
  function initVehicleBar() {
    var active = getActive();
    var m = window.location.pathname.match(/^\/collections\/([^\/]+)(?:\/([^\/]+))?\/?$/);
    if (!active || !active.tag || !m || m[1] === "vendors") return;
    var list = document.querySelector(".product-list--collection") || document.querySelector(".collection__dynamic-part") || document.querySelector(".collection__meta");
    if (!list || document.querySelector(".ggc-vbar")) return;
    var handle = m[1], tagInUrl = m[2] ? decodeURIComponent(m[2]) : "";
    var onFit = tagInUrl === active.tag;
    var count = document.querySelectorAll(".product-list--collection .product-item").length;
    var bar = h("div", { class: "ggc-vbar", role: "region", "aria-label": "Vehicle fit" });
    var txt = h("span", { class: "ggc-vbar__t" });
    var btn = h("button", { class: "ggc-vbar__btn", type: "button" });
    var allUrl = "/collections/all/" + encodeURIComponent(active.tag);
    var link = h("a", { class: "ggc-vbar__a", href: allUrl, text: "Browse all parts for this vehicle" });
    if (onFit && count > 0) {
      txt.textContent = "Showing parts that fit your " + active.label + ".";
      btn.textContent = handle === "all" ? "Clear vehicle" : "Show all in this category";
      btn.addEventListener("click", function () {
        if (handle === "all") { localStorage.removeItem(ACTIVE_KEY); window.location.assign("/collections/all"); }
        else window.location.assign("/collections/" + handle);
      });
      bar.appendChild(txt); bar.appendChild(btn);
    } else if (onFit && count === 0) {
      txt.textContent = "No parts in this category are tagged for your " + active.label + " yet.";
      btn.textContent = handle === "all" ? "Clear vehicle" : "Show all in this category";
      btn.addEventListener("click", function () { window.location.assign(handle === "all" ? "/collections/all" : "/collections/" + handle); });
      bar.appendChild(txt); bar.appendChild(btn); if (handle !== "all") bar.appendChild(link);
    } else if (!tagInUrl) {
      txt.textContent = "Shopping for " + active.label + ".";
      btn.textContent = "Show only parts that fit";
      btn.disabled = true;
      var url = "/collections/" + handle + "/" + encodeURIComponent(active.tag);
      fetch(url, { credentials: "same-origin" }).then(function (r) { return r.text(); }).then(function (html) {
        var mm = html.match(/collection_count">\s*\(([\d,]+)\)/);
        var n = mm ? parseInt(mm[1].replace(/,/g, ""), 10) : null;
        if (n === null) { btn.textContent = "Show only parts that fit"; btn.disabled = false; }
        else if (n > 0) { btn.textContent = "Show only parts that fit my " + active.label + " (" + n + ")"; btn.disabled = false; }
        else { btn.textContent = "No exact-fit parts here yet"; btn.disabled = true; if (handle !== "all") bar.appendChild(link); }
      }).catch(function () { btn.disabled = false; });
      btn.addEventListener("click", function () { window.location.assign(url); });
      bar.appendChild(txt); bar.appendChild(btn);
    } else { return; }
    if (list.classList.contains("product-list--collection")) list.insertAdjacentElement("beforebegin", bar); else list.insertAdjacentElement("afterbegin", bar);
  }

  /* sidebar chip for the saved vehicle */
  function initSidebarChip() {
    var a = getActive(); var box = document.querySelector(".easysearch-collection-block");
    if (!a || !a.label || !box || box.querySelector(".ggc-vchip")) return;
    var chip = h("span", { class: "ggc-vchip" }); chip.appendChild(h("span", { text: a.label }));
    var x = h("button", { type: "button", "aria-label": "Remove saved vehicle", text: "\u00d7" });
    x.addEventListener("click", function () { localStorage.removeItem(ACTIVE_KEY); window.location.reload(); });
    chip.appendChild(x); box.appendChild(chip);
  }
  document.addEventListener("click", function (e) {
    var t = e.target.closest && e.target.closest("[data-ggc-more]"); if (!t) return;
    t.closest(".ggc-filt__g").classList.toggle("is-expanded");
    t.textContent = t.closest(".ggc-filt__g").classList.contains("is-expanded") ? "Show fewer" : "Show all patterns";
  });

  function init() {
    initVehicleBar();
    initSidebarChip();
    var nodes = document.querySelectorAll("[data-ggc-ymm]");
    nodes.forEach(function (n) { if (!n.__ggcInit) { n.__ggcInit = true; new GGCYmm(n); } });
    initFitmentBadges();
    buildGarageUI();
  }

  /* ---------- Persistent right-edge GARAGE tab + panel (like Nexus) ---------- */
  function buildGarageUI() {
    if (window.__ggcGarageUI || !document.body) return;
    window.__ggcGarageUI = true;

    var tab = h("button", { class: "ggc-ymm-garage-tab", type: "button", "aria-label": "Open garage" });
    var icon = h("span"); icon.innerHTML = '<svg viewBox="0 0 20 20" width="18" height="18" fill="currentColor"><path d="M0 17.25V7.3a2 2 0 0 1 1.26-1.86l8.37-3.37c.24-.1.5-.1.74 0l8.37 3.37A2 2 0 0 1 20 7.3v9.95c0 .41-.33.75-.75.75h-1.5a.75.75 0 0 1-.75-.75v-8.3a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v8.3c0 .41-.33.75-.75.75H.75a.75.75 0 0 1-.75-.75Z"/></svg>';
    tab.appendChild(icon);
    tab.appendChild(h("span", { class: "ggc-ymm-garage-tab__label", text: "GARAGE" }));

    var panel = h("div", { class: "ggc-ymm-garage-panel" });
    var overlay = h("div", { class: "ggc-ymm-garage-overlay" });
    document.body.appendChild(overlay);
    document.body.appendChild(panel);
    document.body.appendChild(tab);

    function close() { panel.classList.remove("is-open"); overlay.classList.remove("is-open"); }
    function open() { renderPanel(); panel.classList.add("is-open"); overlay.classList.add("is-open"); }
    overlay.addEventListener("click", close);

    function renderPanel() {
      var garage = readJSON(GARAGE_KEY, []);
      var active = getActive();
      panel.innerHTML = "";
      var head = h("div", { class: "ggc-ymm-garage-panel__head" });
      head.appendChild(h("span", { text: "My Garage" }));
      var x = h("button", { class: "ggc-ymm-garage-panel__close", type: "button", text: "×", "aria-label": "Close" });
      x.addEventListener("click", close); head.appendChild(x);
      panel.appendChild(head);

      if (active && active.label) {
        var act = h("div", { class: "ggc-ymm-garage-panel__active" });
        act.appendChild(h("span", { class: "ggc-ymm-garage-panel__caption", text: "Shopping for" }));
        act.appendChild(h("strong", { text: active.label }));
        panel.appendChild(act);
      }

      var list = h("div", { class: "ggc-ymm-garage-panel__list" });
      if (!garage.length) list.appendChild(h("div", { class: "ggc-ymm-garage-panel__empty", text: "No saved vehicles yet. Add one to shop parts that fit." }));
      garage.forEach(function (g) {
        var row = h("div", { class: "ggc-ymm-garage-panel__row" + (active && active.tag === g.tag ? " is-active" : "") });
        var shop = h("button", { class: "ggc-ymm-garage-panel__shop", type: "button", text: g.label });
        shop.addEventListener("click", function () {
          setActive(g); writeJSON(LAST_KEY, { year: g.year, make: g.make, model: g.model });
          window.location.assign("/collections/all/" + encodeURIComponent(g.tag));
        });
        var del = h("button", { class: "ggc-ymm-garage-panel__del", type: "button", text: "×", "aria-label": "Remove " + g.label });
        del.addEventListener("click", function (e) {
          e.stopPropagation();
          var gg = readJSON(GARAGE_KEY, []).filter(function (x) { return !(x.tag === g.tag && x.label === g.label); });
          writeJSON(GARAGE_KEY, gg); renderPanel();
        });
        row.appendChild(shop); row.appendChild(del); list.appendChild(row);
      });
      panel.appendChild(list);

      var add = h("button", { class: "ggc-ymm-garage-panel__add", type: "button", text: "+ Add a vehicle" });
      add.addEventListener("click", function () { close(); openYmmModal(); });
      panel.appendChild(add);
    }

    tab.addEventListener("click", open);
    window.GGCGarageRefresh = function () { if (panel.classList.contains("is-open")) renderPanel(); };
  }

  /* ---------- Product-page "Verify fitment" badge ---------- */
  function openYmmModal() {
    var btn = document.querySelector(".custm-button");
    if (btn) { btn.click(); return; }
    var modal = document.querySelector(".size-shop-modal");
    if (modal) modal.classList.add("show");
  }

  function initFitmentBadges() {
    var els = document.querySelectorAll("[data-ggc-fit]");
    Array.prototype.forEach.call(els, function (el) {
      if (el.__ggcFit) return; el.__ggcFit = true;
      renderFitmentBadge(el);
    });
  }

  function renderFitmentBadge(el) {
    var fitTags = (el.getAttribute("data-fit-tags") || "").split(/\s+/).filter(Boolean);
    var active = getActive();
    el.innerHTML = "";
    var box = h("div", { class: "ggc-fit__box" });
    if (!active || !active.tag) {
      box.className = "ggc-fit__box ggc-fit__box--prompt";
      box.appendChild(h("span", { class: "ggc-fit__text", text: "Select your vehicle to check fitment" }));
      var pick = h("button", { class: "ggc-fit__btn", type: "button", text: "Shop Your Ride" });
      pick.addEventListener("click", function () { openYmmModal(); });
      box.appendChild(pick);
    } else {
      var fits = fitTags.indexOf(active.tag) !== -1;
      box.className = "ggc-fit__box " + (fits ? "ggc-fit__box--yes" : "ggc-fit__box--no");
      box.appendChild(h("span", { class: "ggc-fit__icon", text: fits ? "✓" : "✕" }));
      box.appendChild(h("span", { class: "ggc-fit__text",
        text: (fits ? "This part fits your " : "This part does NOT fit your ") + active.label }));
      var change = h("button", { class: "ggc-fit__change", type: "button", text: "Change vehicle" });
      change.addEventListener("click", function () { openYmmModal(); });
      box.appendChild(change);
    }
    el.appendChild(box);
  }
  window.GGCRenderFitment = initFitmentBadges;

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  window.GGCYmmInit = init;
})();
